var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1272_2868)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 10C1.6 5.36081 5.36081 1.6 10 1.6C14.6392 1.6 18.4 5.36081 18.4 10C18.4 14.6392 14.6392 18.4 10 18.4C5.36081 18.4 1.6 14.6392 1.6 10ZM10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM15.1269 7.99191C15.4258 7.66657 15.4044 7.16049 15.0791 6.86155C14.7537 6.56261 14.2476 6.58402 13.9487 6.90936L9.23887 12.0352L6.22222 9.08677C5.90625 8.77794 5.39975 8.78374 5.09092 9.09971C4.78209 9.41568 4.78789 9.92218 5.10386 10.231L8.71055 13.7561L9.30058 14.3328L9.85881 13.7253L15.1269 7.99191Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1272_2868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9ec3e72c1a092832283e0cd36fd21d13.svg";
export { ForwardRef as ReactComponent };